import UIButton from 'UIComponents/button/UIButton';
import UITile from 'UIComponents/tile/UITile';
import UITileSection from 'UIComponents/tile/UITileSection';
import ManualEnrollmentPanel from 'automation-ui-enrollment/components/enrollment/manual/ManualEnrollmentPanel';
import FormattedMessageWithObjectTypeName from 'automation-ui-i18n/FormattedMessageWithObjectTypeName';
import { useState } from 'react';
import EnrollmentListSizeExactAlert from 'automation-ui-canvas/containers/review/EnrollmentListSizeExactAlert';
import EnrollmentListSizeEstimateAlert from 'automation-ui-canvas/containers/review/EnrollmentListSizeEstimateAlert';
import { StyledCriteraBorder } from 'automation-ui-enrollment/components/eventEnrollment/steps/EventEnrollmentReview';
import UIAlert from 'UIComponents/alert/UIAlert';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const getEnrollExistingMode = enrollExistingInformation => {
  if (enrollExistingInformation.listId) {
    return 'LIST';
  }
  if (enrollExistingInformation.selectedObjects && enrollExistingInformation.selectedObjects.length > 0) {
    return 'INDIVIDUAL';
  }
  if (enrollExistingInformation.filterBranch) {
    if (enrollExistingInformation.hasCustomFilters) {
      return 'CUSTOM';
    } else {
      return 'TRIGGERS';
    }
  }
  return undefined;
};
const EnrollExistingManualView = ({
  flow,
  enrollExistingState,
  setEnrollExistingState
}) => {
  const [showManualEnrollPanel, setShowManualEnrollPanel] = useState(false);
  const [isPreviewMode, setIsPreviewMode] = useState(false);
  const enrollExistingMode = getEnrollExistingMode(enrollExistingState);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [showManualEnrollPanel && /*#__PURE__*/_jsx(ManualEnrollmentPanel, {
      onClose: () => {
        setShowManualEnrollPanel(false);
        setIsPreviewMode(false);
      },
      onConfirm: payload => {
        setShowManualEnrollPanel(false);
        setEnrollExistingState(Object.assign({}, payload, {
          hasCustomFilters: payload.mode === 'CUSTOM'
        }));
      },
      objectTypeId: flow.objectTypeId,
      mode: "EXISTING",
      flow: flow.toHybridFlowInterface(),
      presetState: Object.assign({}, enrollExistingState, {
        previewPanelOpen: isPreviewMode
      })
    }), /*#__PURE__*/_jsxs(UITile, {
      compact: true,
      children: [/*#__PURE__*/_jsxs(UITileSection, {
        children: [!enrollExistingMode && /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(StyledCriteraBorder, {
            children: /*#__PURE__*/_jsx(FormattedMessageWithObjectTypeName, {
              objectTypeId: flow.objectTypeId,
              baseLangKey: "platformReview.v2.enrollmentStep.enrollExisting.manual.noRecords_cob"
            })
          }), /*#__PURE__*/_jsx(View, {
            display: "block",
            marginBlockStart: "300",
            children: /*#__PURE__*/_jsx(FormattedMessageWithObjectTypeName, {
              objectTypeId: flow.objectTypeId,
              baseLangKey: "platformReview.v2.enrollmentStep.enrollExisting.manual.noRecords_description_cob"
            })
          })]
        }), enrollExistingMode === 'INDIVIDUAL' && /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(UIAlert, {
            children: /*#__PURE__*/_jsx(FormattedMessageWithObjectTypeName, {
              baseLangKey: "platformReview.v2.enrollmentStep.enrollExisting.manual.individualMode_cob",
              objectTypeId: flow.objectTypeId,
              elements: {
                Bold: 'b'
              },
              options: {
                count: enrollExistingState.selectedObjects.length
              },
              isJsx: true
            })
          }), /*#__PURE__*/_jsx(UIButton, {
            use: "link",
            className: "m-left-1",
            onClick: () => {
              setIsPreviewMode(true);
              setShowManualEnrollPanel(true);
            },
            children: /*#__PURE__*/_jsx(FormattedMessageWithObjectTypeName, {
              baseLangKey: "platformReview.v2.enrollmentStep.enrollExisting.manual.previewRecord_cob",
              objectTypeId: flow.objectTypeId
            })
          })]
        }), enrollExistingMode === 'LIST' && /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx("div", {
            className: "m-bottom-3",
            children: /*#__PURE__*/_jsx(EnrollmentListSizeExactAlert, {
              objectTypeId: flow.objectTypeId,
              listId: enrollExistingState.listId
            })
          }), /*#__PURE__*/_jsx(FormattedMessageWithObjectTypeName, {
            baseLangKey: "platformReview.v2.enrollmentStep.enrollExisting.manual.listMode_cob",
            objectTypeId: flow.objectTypeId,
            elements: {
              Bold: 'b'
            },
            isJsx: true
          })]
        }), (enrollExistingMode === 'TRIGGERS' || enrollExistingMode === 'CUSTOM') && /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx("div", {
            className: "m-bottom-3",
            children: /*#__PURE__*/_jsx(EnrollmentListSizeEstimateAlert, {
              objectTypeId: flow.objectTypeId,
              filterBranch: enrollExistingState.filterBranch
            })
          }), /*#__PURE__*/_jsx(FormattedMessageWithObjectTypeName, {
            baseLangKey: "platformReview.v2.enrollmentStep.enrollExisting.manual.customFilterMode_cob",
            objectTypeId: flow.objectTypeId,
            elements: {
              Bold: 'b'
            },
            isJsx: true
          })]
        })]
      }), /*#__PURE__*/_jsxs(UITileSection, {
        children: [/*#__PURE__*/_jsx(UIButton, {
          size: "small",
          use: "tertiary-light",
          onClick: () => setShowManualEnrollPanel(true),
          children: enrollExistingMode ? /*#__PURE__*/_jsx(FormattedMessageWithObjectTypeName, {
            baseLangKey: "platformReview.v2.enrollmentStep.enrollExisting.manual.editManuallyEnroll_cob",
            objectTypeId: flow.objectTypeId
          }) : /*#__PURE__*/_jsx(FormattedMessageWithObjectTypeName, {
            baseLangKey: "platformReview.v2.enrollmentStep.enrollExisting.manual.manuallyEnroll_cob",
            objectTypeId: flow.objectTypeId
          })
        }), enrollExistingMode && /*#__PURE__*/_jsx(UIButton, {
          size: "small",
          use: "danger",
          onClick: () => setEnrollExistingState({
            selectedObjects: [],
            hasCustomFilters: false
          }),
          children: /*#__PURE__*/_jsx(FormattedMessageWithObjectTypeName, {
            baseLangKey: "platformReview.v2.enrollmentStep.enrollExisting.manual.clearManuallyEnrolled_cob",
            objectTypeId: flow.objectTypeId
          })
        })]
      })]
    })]
  });
};
export default EnrollExistingManualView;